import 'react-awesome-animated-number/dist/index.css';

import classNames from 'classnames';
import React, {ReactElement} from 'react';

import {MoneyIcon, ProductionIcon} from '../../../resources/Icons';
import {useBreakpoint} from '../../common/util/useBreakpoint';
import {useGameStatus} from '../hooks';
import AnimatedNumberPill from './buttons/AnimatedNumberPill';

type Props = {wrapperRef?: React.RefObject<HTMLDivElement>};

const Balance = ({wrapperRef}: Props): ReactElement => {
  const gameStatus = useGameStatus();
  const {isMobile} = useBreakpoint('mobile');

  return (
    <div
      ref={wrapperRef}
      className={classNames(
        'flex shrink-0 pb-[3px]',
        isMobile ? 'flex-row justify-between gap-xs' : 'flex-col mt-xl mx-auto gap-sm content-center',
        'mobile:-mx-[2.08%] mobile:px-[2.08%] mobile:overflow-x-auto'
      )}
    >
      <AnimatedNumberPill
        id="totalBalance"
        icon={<MoneyIcon className="h-[45px] w-[45px]" />}
        label={'Total balance'}
        numberPrefix={gameStatus.money < 0 ? '-£' : '£'}
        number={gameStatus.money}
        danger={gameStatus.money < 0}
        normalizeValue
        hasComma
      />
      <AnimatedNumberPill
        id="production"
        icon={<ProductionIcon />}
        label={'Production'}
        number={+gameStatus.totalProduction.toFixed(2)}
        numberSuffix="t"
        hasComma={false}
      />
    </div>
  );
};

export default Balance;
